//折叠效果
var elements = document.querySelectorAll('.product-short-description, .des_accordion');
elements.forEach(function(element) {
  var acc = element.getElementsByTagName("h3");
  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }
});

// 响应式表格
  document.addEventListener("DOMContentLoaded", function() {
    var tables = document.querySelectorAll("table:not(.class)");
    for (var i = 0; i < tables.length; i++) {
      if (tables[i]) {
        tables[i].classList.add("table", "table-bordered", "table-hover");
        var wrapper = document.createElement("section");
        wrapper.classList.add("table-responsive");
        if (tables[i].parentNode) {
          tables[i].parentNode.insertBefore(wrapper, tables[i]);
          wrapper.appendChild(tables[i]);
        }
      }
    }
  });


//客户评论
document.addEventListener('DOMContentLoaded', function () {
  var cratingCount; // 在共享的作用域中声明 cratingCount 变量

  setTimeout(function () {
    var cratingcountElement = document.querySelector('.cratingcount');
    if (cratingcountElement) {
      var cratingCountText = cratingcountElement.textContent.trim();
      // 过滤掉非数字字符，只保留数字部分
      cratingCountText = cratingCountText.replace(/\D/g, ''); 
      cratingCount = parseInt(cratingCountText, 10); // 定义 cratingCount 变量
    } else {
      cratingCount = 2;
    }

    var prevBadgeElements = document.querySelectorAll('.jdgm-prev-badge__text');

    prevBadgeElements.forEach(function (element) {
      var textContent = element.textContent.trim();
      var match = textContent.match(/\b\d+\b/);

      if (match && match.length > 0) {
        var number = parseInt(match[0], 10);
        var newTextContent = cratingCount + number;

        // Apply visibility: visible !important; style
        element.style.visibility = 'visible';
        element.style.setProperty('visibility', 'visible', 'important'); // Add !important
        // Preserve the original text
        element.textContent = textContent.replace(match[0], newTextContent);
      }
    });

    var firstHistogramElement = document.querySelector('.jdgm-histogram__frequency');

    if (firstHistogramElement) {
      var textContent = firstHistogramElement.textContent.trim();
      var match = textContent.match(/\b\d+\b/);

      if (match && match.length > 0) {
        var number = parseInt(match[0], 10);
        var newTextContent = cratingCount + number;

        // Apply visibility: visible !important; style
        firstHistogramElement.style.visibility = 'visible';
        firstHistogramElement.style.setProperty('visibility', 'visible', 'important'); // Add !important
        // Preserve the original text
        firstHistogramElement.textContent = textContent.replace(match[0], newTextContent);
      }
    }

    var summaryElement = document.querySelector('.jdgm-rev-widg__summary-text');

    if (summaryElement) {
      var textContent = summaryElement.textContent.trim();
      var match = textContent.match(/\b\d+\b/);

      if (match && match.length > 0) {
        var number = parseInt(match[0], 10);
        var newTextContent = cratingCount + number;

        summaryElement.textContent = textContent.replace(match[0], newTextContent);
      } 
    }
  }, 3000); // 延迟 1 秒钟
});

//youtube引用视频
function resizeVideo() {
    var videos = document.querySelectorAll(".youtube-video, #youtube-video");
    videos.forEach(function(video) {
        var containerWidth = video.offsetWidth;
        video.style.height = (containerWidth * 9 / 16) + "px"; // 假设是 16:9 的宽高比
    });
}

window.addEventListener("resize", resizeVideo);

window.onload = function() {
    resizeVideo();
};


// 支持多个自定义 tab 容器
document.addEventListener('DOMContentLoaded', function () {
  // 获取页面中所有 .mytab1 容器
  const tabContainers = document.querySelectorAll('.mytab1');

  tabContainers.forEach(tabContainer => {
    const tabButtons = tabContainer.querySelectorAll('.tabbed-content--tabs button');
    const tabContents = tabContainer.querySelectorAll('.cus-tabbed-content');

    if (tabButtons.length && tabContents.length) {
      // 默认显示第一个 tab
      tabButtons[0].classList.add('active');
      tabContents[0].classList.add('active');

      // 给每个按钮添加点击事件
      tabButtons.forEach((button, index) => {
        button.addEventListener('click', function () {
          // 清除当前 tab 容器中的 active 类
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabContents.forEach(content => content.classList.remove('active'));

          // 激活当前点击项
          this.classList.add('active');
          tabContents[index].classList.add('active');
        });
      });
    }
  });
});


